(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(".swiper--multicolumn");
    if (!sliderEl) return;

    // Prevent duplicate initialization
    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    const slidesPerViewDesktop = Number(
      sliderEl.dataset.slidesDesktop || 6
    );

    const slidesPerViewMobile = Number(
      sliderEl.dataset.slidesMobile || 1.3
    );

    const totalSlides = sliderEl.querySelectorAll(".swiper-slide").length;
    if (window.innerWidth >= 990 && totalSlides <= slidesPerViewDesktop) {
      return;
    }

    new Swiper(sliderEl, {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 16,
      speed: 800,
      watchSlidesProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },

      breakpoints: {
        990: {
          slidesPerView: slidesPerViewDesktop,
        },
      },
    });
  };

  const initMulticolumn = (section) => {
    if (!section?.classList.contains("multicolumn-section")) {
      return;
    }

    initSlider(section);
  };

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".multicolumn-section")
      .forEach(initMulticolumn);
  });

  document.addEventListener("shopify:section:load", (e) => {
    initMulticolumn(e.target);
  });

  document.addEventListener("shopify:section:reorder", (e) => {
    initMulticolumn(e.target);
  });
})();